import React, { useEffect, useState } from 'react';
import TettraEditor from '../../tettra-editor/components/TettraEditor';
import { teamPreferencesToEditorState } from '../../tettra-editor/utilities/contentToEditorState';
import editorStateToRawContent from '../../tettra-editor/utilities/editorStateToRawContent';
import { canEditTeamHome } from '../../utilities/permissionsUtilities';
import { getApiTeamPreferenceUrl } from '../../utilities/urlHelper';
import editorStateToHTML from '../../tettra-editor/utilities/editorStateToHTML';

const EDITOR_CONFIG = {
    enableSmallEditor: true,
    spellCheck: true,
    enableAutosave: false,
    enableTables: false,
    enableInsertControls: false,
    enableMentionSuggestions: true,
    enableInternalSuggestions: true,
    enableExternalSuggestions: false,
    enableFileUpload: false,
};

const EditTeamHomeModal = (props) => {
    const [showSuccess, setShowSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [editorState, setEditorState] = useState(teamPreferencesToEditorState(null));
    const html = editorStateToHTML(editorState);
    const contentStateJSON = JSON.stringify(editorStateToRawContent(editorState));

    useEffect(() => {
        $.get(getApiTeamPreferenceUrl())
            .done(({ preferences }) => {
                setEditorState(teamPreferencesToEditorState(preferences));
            });
    }, []);

    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            closeModal();
        }
    };

    const closeModal = () => {
        if (props.closeModal) {
            props.closeModal();
        }
    };

    const saveDescription = () => {
        if (submitting) {
            return;
        }

        setSubmitting(true);

        $.ajax({
            type: 'PUT',
            url: getApiTeamPreferenceUrl(),
            data: {
                description: html,
                description_content_state: contentStateJSON,
            },
        }).done(({ success }) => {
            if (success) {
                setShowSuccess(true);
                setTimeout(() => window.location.reload(false), 1000);
            }
        }).catch(console.error)
            .always(() => {
                setSubmitting(false);
            });
    };

    if (canEditTeamHome()) {
        return (
            <div className="react-modal open move-page-modal" onMouseDown={onClickModal}>
                <div className="modal-content">
                    {showSuccess && <div className="modal-notification mxn2 myn2 rounded-top">Description updated!</div>}
                    <h2>Edit team home</h2>
                    <div className="question-editor mb3">
                        <TettraEditor
                            config={EDITOR_CONFIG}
                            editorState={editorState}
                            updateModel={setEditorState}
                            setUploading={() => {}}
                        />
                    </div>
                    <div className="right-align">
                        <span className="react-modal-close btn-secondary mr1" onClick={closeModal}>Cancel</span>
                        <span className="btn btn-primary" onClick={saveDescription}>Save</span>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default EditTeamHomeModal;
